import React from 'react';
import AssessmentsView from '../Assessments/AssessmentsView';
import {useMatch, useResolvedPath} from 'react-router-dom';
import { useStores } from '../../hooks/use-stores';
import { useNavigate } from 'react-router';
import { joinPath } from '../../utils/helpers';

function DemoAssessment({ parentMatch, companyId, uniqueId, isAdmin }) {

    const resolved = useResolvedPath('.');
    const baseUrl = resolved.pathname;
    const navigate = useNavigate();
    const { demoStore } = useStores();
    const { demoUser } = demoStore;

    const handleOnFinish = () => {
        isAdmin
            ? navigate(joinPath(match.url, 'finish'))
            : navigate(joinPath(match.url, 'give-feedback'));
    };

    const restartDemo = () => {
        demoStore.restart();
    };

    return (
        <AssessmentsView
            parentUrl={baseUrl}
            companyId={companyId}
            currentUser={demoUser}
            assessmentId={uniqueId}
            assessmentStore={demoStore}
            questionStore={demoStore}
            language={'en'}
            redirectOnError={false}
            isDemo
            restartDemo={restartDemo}
            onClose={handleOnFinish}
        />
    );
}

export default DemoAssessment;
